<template>
  <div class="pt-6 divide-y divide-gray-200 relative">
    <div class="px-4 sm:px-6">
      <div>
        <h2 class="text-lg leading-6 font-medium text-gray-900">
          FAA UAS Docs
        </h2>
        <p class="mt-1 text-sm text-gray-500">
          If you upload drone video, you must, first, upload all relevant
          supporting documentation including FAA UAS license, FAA UAS renewal,
          and all applicable waivers.
        </p>
      </div>
      <div class="mt-6 flex flex-col lg:flex-row">
        <div class="w-full bg-white rounded-md -space-y-px">
          <div
            class="border-gray-200 relative border p-4 flex flex-row items-center"
            :class="{
              'rounded-tl-md rounded-tr-md': index == 0,
              'rounded-bl-md rounded-br-md': index == faaDocs.length - 1
            }"
            v-for="(doc, index) in faaDocs"
            v-bind:key="doc.id"
          >
            <span
              class="w-2 h-2 rounded-full bg-yellow-600 inline-block cursor-pointer"
              title="Pending Approval"
              v-tippy
              v-if="!doc.approved"
            ></span>
            <span
              class="w-2 h-2 rounded-full bg-green-600 inline-block cursor-pointer"
              title="Active"
              v-tippy
              v-if="doc.approved"
            ></span>
            <div class="flex-1 flex items-center text-sm">
              <span
                id="pricing-plans-0-label"
                class="ml-3 font-medium text-gray-900"
                >{{ doc.displayType }}</span
              >
            </div>
            <div class="text-gray-600">
              <span>{{
                doc.expires_at | displayLocalDateTime("MM-DD-YYYY")
              }}</span>
            </div>
            <button
              class="flex items-center ml-4 text-gray-600 hover:text-gray-900 transition focus:outline-none"
              v-on:click="viewDoc(doc)"
            >
              <i class="fad fa-download"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <button
      class="absolute top-0 right-0 mt-4 mr-4 rounded-full h-8 w-8 bg-blue-700 text-white flex items-center justify-center hover:bg-blue-500 transition-all focus:outline-none"
      v-on:click="viewAddFaaDocumentationModal"
    >
      <i class="fa fa-plus"></i>
    </button>
    <FaaUploadModal />
  </div>
</template>
<script>
import * as Config from "@/config";
import { mapGetters } from "vuex";

import FaaUploadModal from "@/screens/stringer/modals/FaaUploadDocument";

export default {
  name: "StringerSettingsFaa",
  data() {
    return {
      faaDocs: []
    };
  },
  components: { FaaUploadModal },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    this.getUserFaaDocs();
  },
  methods: {
    ...mapGetters(["getAuthorizationHeader"]),
    getUserFaaDocs() {
      var _this = this;
      this.$http
        .get(
          Config.apiPath + "/api/v2/stringer/account/faadocs",
          this.getAuthorizationHeader()
        )
        .then(response => {
          _this.faaDocs = response.data;
        });
    },
    viewAddFaaDocumentationModal() {
      this.$eventBus.$emit("settings-faa-upload-open-modal");
    },
    viewDoc(doc) {
      this.$http
        .post(
          Config.apiPath + "/api/v2/stringer/account/faadocs/download",
          {
            id: doc.id
          },
          this.getAuthorizationHeader()
        )
        .then(
          response => {
            var link = document.createElement("a");
            document.body.appendChild(link);
            link.href = response.data;
            link.click();
            document.body.removeChild(link);
          },
          () => {
            alert(
              "You do not own this video, therefore you cannot download it."
            );
          }
        );
    }
  }
};
</script>
